import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Paths from 'routes';
import useStore from 'store';
import { getAccessToken, getUserDiv, removeTokens } from 'utils/token-utils';
import { UserOutlined } from '@ant-design/icons';
import { Button } from 'components/atoms';
import './index.scss';

export interface UserInfoProps {}

const UserInfo = ({}: React.PropsWithChildren<UserInfoProps>): React.ReactElement => {
  /* ======================================================
   * stores
   * ====================================================== */
  const auth = useStore((state) => state.auth);  
  const reset = useStore((state) => state.reset);

  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();

  /* ======================================================
   * events
   * ====================================================== */
  const onClickLogout = useCallback((e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    removeTokens();
    reset();
    navigate(Paths.pathObject.login);
  }, []);

  /* ======================================================
   * render items
   * ====================================================== */

  return (
    <>
      {getAccessToken() && (
        <div className="cr-user-info light">
          <UserOutlined />
            {(auth.login?.isCm || auth.login?.isPm || auth.login?.isOp || auth.login?.div === '101')?(
              <a href="/myroom"><span className="cr-user-name">{auth.login?.name}님</span></a>
            ):(
              <span className="cr-user-name">{auth.login?.name}님</span>
            )} &nbsp;
          <Button rounded onClick={onClickLogout} size='small'>로그아웃</Button>
        </div>
      )}
    </>
  );
};

export default UserInfo;
